import React, { useContext } from 'react'
import { CalculatorResultsContext } from '../Store/CalculatorResultsContext';
import { CalculatorStepsContext } from '../Store/CalculatorStepsContext';
import { initialCalculatorInputs } from '../../model/CalculatorInputs';
import { CalculatorSteps } from '../../model/CalculatorSteps';
import { none } from 'fp-ts/lib/Option';
import { analyticsToolRestartEvent } from '../../utils/Analytics';

export const RestartOrEditSettings = () => {

    const { steps, setSteps } = useContext(CalculatorStepsContext);
    const resultsStore = useContext(CalculatorResultsContext);

    function handleStartOver() {
        setSteps(steps
            .withInputs(initialCalculatorInputs)
            .withStepIndex(CalculatorSteps.STEP_1_ENTER_PREMIUM_CHOOSE_TERM));
        resultsStore.restart();
        analyticsToolRestartEvent("Start Over");
    }

    function handleEditSettings() {
        resultsStore.setResults(none);
        resultsStore.setError(none);
        resultsStore.setLoading(false);
        analyticsToolRestartEvent("Edit Settings");
    }


    return (
        <div className="restart-or-edit-settings">
            <span className="restart"><a href="#" onClick={handleStartOver}> <i className="fa fa-arrow-left" ></i> Start over </a></span>
            <span className="edit-settings"><a href="#" onClick={handleEditSettings}> <i className="fa fa-pencil-square-o" ></i> Edit settings </a></span>
        </div >
    )
}


